import { getLastDateTimeOfMonth } from 'utils/helpers';

const currentDate = new Date();

export const availableInvoicesDateLimits = {
  min: { month: 4, year: 2021 },
  max: {
    month: currentDate.getMonth(),
    year: currentDate.getFullYear(),
  },
};

export const minDateSelection = new Date(
  availableInvoicesDateLimits.min.year,
  availableInvoicesDateLimits.min.month,
  1,
);

export const maxDateSelection = getLastDateTimeOfMonth(
  currentDate.getFullYear(),
  currentDate.getMonth(),
);
